import React, { useRef, useEffect } from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import OptionsChipEditor from "./OptionsChipEditor";

export default function TemplateFieldRow({
  id,
  field,
  index,
  lastIndex,
  addField,
  onUpdate,
  onDelete
}) {
  const labelRef = useRef(null);

  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition
  } = useSortable({ id });



  const style = {
    transform: CSS.Transform.toString(transform),
    transition
  };

  const update = (patch) => {
    onUpdate(index, { ...field, ...patch });
  };
  const isSelect = field.type === "select";
  const isMedia = field.type === "media";

  useEffect(() => {
    if (field.autoFocus && labelRef.current) {
      labelRef.current.focus();

      update({
        autoFocus: false
      });
    }
  }, [field.autoFocus]);

  if (!field) return null;

  return (
    <tr ref={setNodeRef} style={style}>

      {/* drag handle */}
      <td
        {...attributes}
        {...listeners}
        style={{
          cursor: "grab",
          textAlign: "center",
          width: 30
        }}
      >
        ⋮⋮
      </td>
      {/* Row number */}
      <td className="row-number">
        {index + 1}
      </td>
      {/* label */}
      <td>
        <input
          ref={labelRef}
          className="compact-input"
          value={field.label || ""}
          onChange={(e) =>
            update({ label: e.target.value })
          }
          placeholder="Field Label"
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();

              if (index === lastIndex) {
                addField();
              }
            }
          }}
        />
      </td>

      {/* type selector */}
      <td>
      <select
        className="compact-select"
        value={field.type}
        onChange={(e) => {

          const newType = e.target.value;

          const patch = { type: newType };

          // switching TO media
          if (newType === "media") {
            patch.options = [];
            patch.mediaOptions = {
              type: "photo",
              maxVideoSeconds: 15
            };
          }

          // switching TO select
          if (newType === "select") {
            patch.options = [];
            delete patch.mediaOptions;
          }

          // switching TO text
          if (newType === "text") {
            patch.options = [];
            delete patch.mediaOptions;
          }

          update(patch);

        }}
      >
      <option value="text">Text</option>
      <option value="number">Number</option>
      <option value="date">Date</option>
      <option value="select">Drop-down</option>
      <option value="media">Media</option>
      </select>
      </td>

      {/* options column */}
      <td>

        {isSelect && (
          <OptionsChipEditor
            value={field.options || []}
            onChange={(opts) =>
              update({ options: opts })
            }
          />
        )}

        {isMedia && (

          <div className="media-options">

            <label>
              <input
                type="radio"
                name={`media-${id}`}
                checked={field.mediaOptions?.type === "photo"}
                onChange={() =>
                  update({
                    mediaOptions: {
                      type: "photo",
                      maxVideoSeconds: field.mediaOptions?.maxVideoSeconds ?? 15
                    }
                  })
                }
              />
              Photo
            </label>

            <label>
              <input
                type="radio"
                name={`media-${id}`}
                checked={field.mediaOptions?.type === "video"}
                onChange={() =>
                  update({
                    mediaOptions: {
                      type: "video",
                      maxVideoSeconds: field.mediaOptions?.maxVideoSeconds ?? 15
                    }
                  })
                }
              />
              Video
            </label>

          </div>

        )}

      </td>

      {/* delete */}
      <td style={{ whiteSpace: "nowrap" }}>
        <button
          className="btn-delete"
          onClick={() => onDelete(index)}
        >
          Delete
        </button>
      </td>

    </tr>
  );
}
